import React from 'react'
import { useState } from 'react';
import App from "./App";


const Extra = ({movie}) => {
  const [isShown, setIsShown] = useState(false);
  const hello=()=>{
    setIsShown(current => !current)
 }

  return (
    <>
    <div>
      <h5>{movie.title}</h5>
      <img src={"https://image.tmdb.org/t/p/w500" + movie.backdrop_path} alt={movie.path} onClick={hello}  />

    </div>
    <div>
        {
isShown &&(
  
   <App  key={movie.id} movie={movie} />
  )
        }
      </div>
    </>
  
  );
};
export default Extra;